<template>
  <div class="login">
    <div >
      <div v-if="!isLogin">
        <span class="text" @click="loginClick">会员登录</span>
        <!-- <span style="font-size: 14px; color: white; padding: 0 3px; min-width: 25px;">or</span> -->
        <!-- <span class="text"  @click="registeredClick">免费注册</span> -->
      </div>
      <div v-else class="is_login">
        您好，{{loginPhone}} <span @click="myInfo" style="color: #238ddf">个人中心</span> <span @click="quitLogin">退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {request} from "@/network/request";

  export default {
    name: "navLogin",
    methods: {
      loginClick() {
        this.$message.error('暂未开通,敬请期待')
        // this.$router.push('/login')
      },
      registeredClick(){
        // this.$router.push('/registered')
        this.$router.push('/registed123456')
      },
      quitLogin(){
        request({
          url: '/logout.action',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
        }).then(res => {
          if(res.data.code === 1){
            this.$message({
              message: res.data.info,
              type: 'success'
            });
            this.isLogin = false
            this.loginPhone = ''
            this.$router.replace('/index')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      myInfo(){
        let url = 'userInfo'
        if(this.userType === 'ROLE_NEWS_ADMIN'){
          url = 'operation'
        }
        this.$router.push('/' + url)
      }
    },
    props: {
      show:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        // 是否登录
        isLogin: false,
        // 用户手机号码
        loginPhone: '',
        // 用户权限
        userType: ''
      }
    },
    beforeCreate() {
      request({
        url: '/user/userInfo',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
      }).then(res => {
        if(res.data.code === 1){
          this.userType = res.data.info.authorities[0].authority
          this.loginPhone = res.data.info.phone
          this.isLogin = true
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
</script>

<style scoped>
  .login{
    text-align: end;
    align-self: center;
    position: absolute;
    right: 10%;
  }

  .text{
    color: white;
    /* color: #04a7f4; */
    font-weight: bold;
  }

  .text:hover{
    font-weight: bold;
    cursor: pointer;
    color: #ff7f17
  }

  .is_login{
    color: white;
  }

  .is_login span{
    /*color: #ff7f17;*/
  }

  .is_login span:hover{
    opacity: .9;
    cursor: pointer;
  }

  @media screen and (max-width: 1600px) {
    .login{
      min-width: 14rem;
    }

    .text{
      font-size: 0.9rem;
      padding: 0 0.1rem;
      min-width: 2rem;
    }

    .text:hover{
      font-size: 1.3rem;
    }

    .is_login{
      font-size: 1.1rem;
      min-width: 30rem;
    }

    .is_login span{
      margin: 0 0 0 0.4rem;
    }
  }

  @media screen and (min-width: 1600px){
    .login{
      min-width: 14rem;
    }

    .text{
      font-size: 13px;
      padding: 0 1px;
      min-width: 20px;
    }

    .text:hover{
      font-size: 14px;
    }

    .is_login{
      font-size: 10px;
      min-width: 300px;
      margin:8px 10px;
    }

    .is_login span{
      margin: 0 0 0 5px;
    }
  }
</style>
